module.exports = __webpack_public_path__ + "assets/b7de62572ebbd02edb55b97fea662cda.svg";